import type { ProfitAgentDrilldown } from '../types/profitabilityAgent';

/** Placeholder labels for Profit Agent client demos (never show real IDs until Demo is on). */
export const PROFIT_AGENT_ENTITY_PLACEHOLDERS = {
  customer: 'Crestwood Manufacturing Ltd',
  vehicle: 'AB12XYZ',
} as const;

const UK_PLATE_RE = /\b[A-Z]{2}\d{2}[A-Z]{3}\b/gi;

/** Mask vehicle regs and known drilldown entity names in agent answer text. */
export function maskProfitAgentDisplayText(
  text: string,
  opts: { mask: boolean; drilldowns?: ProfitAgentDrilldown[] },
): string {
  if (!opts.mask || !text) return text;
  let out = text;
  out = out.replace(UK_PLATE_RE, PROFIT_AGENT_ENTITY_PLACEHOLDERS.vehicle);
  for (const d of opts.drilldowns ?? []) {
    const id = String(d.label ?? d.id ?? '').trim();
    if (!id) continue;
    const placeholder =
      d.type === 'customer'
        ? PROFIT_AGENT_ENTITY_PLACEHOLDERS.customer
        : d.type === 'vehicle'
          ? PROFIT_AGENT_ENTITY_PLACEHOLDERS.vehicle
          : id;
    if (placeholder !== id) {
      out = out.split(id).join(placeholder);
    }
  }
  return out;
}

export function maskProfitAgentDrilldownLabel(
  d: ProfitAgentDrilldown,
  mask: boolean,
): string {
  if (!mask) return d.label ?? d.id;
  if (d.type === 'customer') return PROFIT_AGENT_ENTITY_PLACEHOLDERS.customer;
  if (d.type === 'vehicle') return PROFIT_AGENT_ENTITY_PLACEHOLDERS.vehicle;
  return d.label ?? d.id;
}

/** Strip markdown noise for fleet-manager-facing cards. */
export function stripMarkdownForDisplay(text: string): string {
  return String(text || '')
    .replace(/\r\n/g, '\n')
    .replace(/^#{1,6}\s+/gm, '')
    .replace(/\*\*([^*]+)\*\*/g, '$1')
    .replace(/\*([^*]+)\*/g, '$1')
    .replace(/^\s*[-*•]\s+/gm, '')
    .replace(/^\s*\d+\.\s+/gm, '')
    .trim();
}

export function clampLines(items: string[], maxItems: number, maxChars = 220): string[] {
  return items
    .map((s) => stripMarkdownForDisplay(s))
    .filter(Boolean)
    .slice(0, maxItems)
    .map((s) => (s.length > maxChars ? `${s.slice(0, maxChars - 1)}…` : s));
}
